import { ShepherdService } from 'angular-shepherd';
import Step from 'shepherd.js/src/types/step';
import { ProductTourService } from '../../../../services/product-tour.service';
import { offset } from '@floating-ui/dom';

export const STEPS_BUTTONS = {
	back: {
		classes: 'back-button',
		secondary: true,
		text: 'Back',
		type: 'back',
	},
	cancel: {
		classes: 'cancel-button',
		secondary: true,
		text: 'Exit',
		type: 'cancel',
	},
	next: {
		classes: 'next-button',
		text: 'Next',
		type: 'next',
	},
};

export function getSteps(service: ShepherdService): Step.StepOptions[] {
	const handleNext = () => {
		service.next();
	};

	const handleBack = () => {
		service.back();
	};

	function handleCompleteTour() {
		service.complete();
	}

	function handleCancel() {
		service.cancel();
	}


	return [
		{
			id: 'step3',
			title: 'Complete the company\'s details',
			text: ['Complete the necessary fields for the company\'s details. <br><br><span class="tw-text-sm">This is where you will enter the company details such as the trading name, head office contact details, ABN, etc. (this is the company\'s general details).</span><br><br> Click \'Next\' to proceed.'],
			highlightClass: 'highlight',
			attachTo: {
				element: '.clientDetails',
				on: 'left',
			},
			modalOverlayOpeningRadius: 5,
			modalOverlayOpeningPadding: 1,
			floatingUIOptions: {
				middleware: [offset({ mainAxis: 15, crossAxis: 12 })],
			},
			scrollTo: {
				block: 'center',
				behavior: 'smooth',
			},
			beforeShowPromise: function() {
				return new Promise(function(resolve) {
					setTimeout(function() {
						window.scrollTo(0, 0);
						resolve(null);
					}, 300);
				});
			},
			when: {
				show: () => {
					const closeButton = document.querySelector(`.normalSlideButton`);
					if (closeButton) {
						closeButton.addEventListener('click', handleCancel);
					}
					const xButton: HTMLElement = document.querySelector('[ng-reflect-message="Close"]');
					if (xButton) {
						xButton.addEventListener('click', handleCancel);
					}
				},
				hide: () => {
					const closeButton = document.querySelector(`.normalSlideButton`);
					if (closeButton) {
						closeButton.removeEventListener('click', handleCancel);
					}
					const xButton: HTMLElement = document.querySelector('[ng-reflect-message="Close"]');
					if (xButton) {
						xButton.removeEventListener('click', handleCancel);
					}
				},
				cancel: () => {
					const closeButton = document.querySelector(`.normalSlideButton`);
					if (closeButton) {
						closeButton.removeEventListener('click', handleCancel);
					}
					const xButton: HTMLElement = document.querySelector('[ng-reflect-message="Close"]');
					if (xButton) {
						xButton.removeEventListener('click', handleCancel);
					}
				},
			},
			buttons: [
				{
					text: 'Next',
					action: function() {
						handleNext();
					},
				},
			],
		},
		{
			id: 'step4',
			title: 'Complete the company\'s location',
			text: ['This is where you will enter the company\'s location (generally the head office location). <br><br>Click \'Next\' to proceed.'],
			highlightClass: 'highlight',
			attachTo: {
				element: '.clientLocation',
				on: 'left',
			},
			modalOverlayOpeningRadius: 5,
			modalOverlayOpeningPadding: 1,
			floatingUIOptions: {
				middleware: [offset({ mainAxis: 15, crossAxis: 12 })],
			},
			scrollTo: {
				block: 'center',
				behavior: 'smooth',
			},
			beforeShowPromise: function() {
				return new Promise(function(resolve) {
					setTimeout(function() {
						window.scrollTo(0, 0);
						resolve(null);
					}, 300);
				});
			},
			when: {
				show: () => {
					const closeButton = document.querySelector(`.normalSlideButton`);
					if (closeButton) {
						closeButton.addEventListener('click', handleCancel);
					}
					const xButton: HTMLElement = document.querySelector('[ng-reflect-message="Close"]');
					if (xButton) {
						xButton.addEventListener('click', handleCancel);
					}
				},
				hide: () => {
					const closeButton = document.querySelector(`.normalSlideButton`);
					if (closeButton) {
						closeButton.removeEventListener('click', handleCancel);
					}
					const xButton: HTMLElement = document.querySelector('[ng-reflect-message="Close"]');
					if (xButton) {
						xButton.removeEventListener('click', handleCancel);
					}
				},
				cancel: () => {
					const closeButton = document.querySelector(`.normalSlideButton`);
					if (closeButton) {
						closeButton.removeEventListener('click', handleCancel);
					}
					const xButton: HTMLElement = document.querySelector('[ng-reflect-message="Close"]');
					if (xButton) {
						xButton.removeEventListener('click', handleCancel);
					}
				},
			},
			buttons: [
				{
					text: 'Back',
					classes: 'back-button',
					action: function() {
						handleBack();
					},
				},
				{
					text: 'Next',
					action: function() {
						handleNext();
					},
				},
			],
		},
		{
			id: 'step5',
			title: 'Review the company details',
			text: ['Review the company details -  <br><br>Once you\'ve finished, click \'Save\' to save the company\'s details and finish your tour.'],
			highlightClass: 'highlight',
			attachTo: {
				element: '[data-cy="slideOverOpen"]',
				on: 'left',
			},
			modalOverlayOpeningRadius: 5,
			modalOverlayOpeningPadding: 1,
			floatingUIOptions: {
				middleware: [offset({ mainAxis: 15, crossAxis: 12 })],
			},
			scrollTo: {
				block: 'center',
				behavior: 'smooth',
			},
			beforeShowPromise: function () {
				return new Promise(function (resolve) {
					setTimeout(function () {
						window.scrollTo(0, 0);
						resolve(null);
					}, 300);
				});
			},
			when: {
				show: () => {
					const closeButton = document.querySelector(`.normalSlideButton`);
					if (closeButton) {
						closeButton.addEventListener('click', handleCancel);
					}
					const xButton: HTMLElement = document.querySelector('[ng-reflect-message="Close"]');
					if (xButton) {
						xButton.addEventListener('click', handleCancel);
					}
				},
				hide: () => {
					const closeButton = document.querySelector(`.normalSlideButton`);
					if (closeButton) {
						closeButton.removeEventListener('click', handleCancel);
					}
					const xButton: HTMLElement = document.querySelector('[ng-reflect-message="Close"]');
					if (xButton) {
						xButton.removeEventListener('click', handleCancel);
					}
				},
				cancel: () => {
					const closeButton = document.querySelector(`.normalSlideButton`);
					if (closeButton) {
						closeButton.removeEventListener('click', handleCancel);
					}
					const xButton: HTMLElement = document.querySelector('[ng-reflect-message="Close"]');
					if (xButton) {
						xButton.removeEventListener('click', handleCancel);
					}
				},
			},
			buttons: [
				{
					text: 'Back',
					classes: 'back-button',
					action: function () {
						handleBack();
					},
				},
				{
					text: 'Save',
					action: function () {
						const saveButton: HTMLElement = document.querySelector('.primarySlideButton');
						saveButton.click();
					},
				},
			],
		},
	];
}
